
    <div class="h-screen flex w-full surface-ground">
        <div
            class="flex flex-1 flex-column surface-ground align-items-center justify-content-center"
        >
        <p-card [style]="{border: '1px solid ##5297ff'}">
            <div class="w-11 sm:w-30rem">
                <div class="flex flex-column">
                    <div
                        style="height: 56px; width: 56px"
                        class="bg-primary-50 border-circle flex align-items-center justify-content-center"
                    >
                        <i class="pi pi-sign-in text-primary text-4xl"></i>
                    </div>
                    <div class="mt-4">
                        <h1 class="m-0 text-primary font-semibold text-4xl">
                            Ushers Report
                        </h1>
                        <span class="block text-700 mt-2"
                            >Please fill the fields to sign-in</span
                        >
                    </div>
                </div>
               
                <div class="flex flex-column gap-3 mt-6">
                    <p-messages severity="error" *ngIf="failed">
                        <ng-template pTemplate>
                            <div class="ml-2">Authentication failed. Please request access from the administrator.</div>
                        </ng-template>
                    </p-messages>
                    <p-inputGroup>
                        <p-inputGroupAddon>
                            <i class="pi pi-user"></i>
                        </p-inputGroupAddon>
                        <input type="text" [disabled]="loading" pInputText placeholder="Email" [(ngModel)]="obj['email']" />
                    </p-inputGroup>
                    <p-inputGroup>
                        <p-inputGroupAddon>
                           <a (click)="show()"> <i class="pi pi-eye"></i></a>
                        </p-inputGroupAddon>
                        <input type="{{ passwordHidden ? 'password' : 'text' }}" [disabled]="loading" pInputText placeholder="Password" [(ngModel)]="obj['password']" />
                    </p-inputGroup>
                    <div>
                        <button
                            pButton
                            pRipple
                            class="w-full"
                            label="LOGIN"
                            (click)="login()" 
                            [loading]="loading"
                        ></button>
                    </div>
                   <!--<div>
                        <button
                            pButton
                            pRipple
                            class="w-full p-button-text text-primary-500"
                            label="FORGOT PASSWORD?"
                        ></button>
                    </div>--> 
                </div>
            </div>
        </p-card>

        
            
        </div>
        <div
            [style.background]="
                'url(assets/ushers/images/layer-0-opt.webp)'
            "
            class="hidden lg:flex flex-1 align-items-center justify-content-center bg-cover"
        >
            <img src="assets/layout/images/logo_pmcc4w.webp" width="250" alt="" />
        </div>
    
    </div>
    <!--<app-config [minimal]="true"></app-config>-->

